import styled from 'styled-components';

export const StyledAddBroadsider = styled.div`
  width: ${({ theme }) => theme.avatarSize};
  height: ${({ theme }) => theme.avatarSize};
  cursor: pointer;
  position: relative;
  border: dashed ${({ theme }) => theme.buttonFrameWidth} ${({ theme }) => theme.frame};
  background: ${({ theme }) => theme.buttonDark};
  transition: background linear 0.2s;

  .add-bsider-img {
    transition: scale linear 0.2s;
    width: 100%;
    height: 100%;
  }

  .add-bsider-decorator {
    width: calc(24px + ${({ theme }) => theme.buttonFrameWidth} * 2);
    height: calc(24px + ${({ theme }) => theme.buttonFrameWidth} * 2);
    background: transparent;
    padding: ${({ theme }) => theme.buttonFrameWidth};
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: calc(${({ theme }) => '-' + theme.buttonFrameWidth} * 2);
    margin-left: calc(${({ theme }) => '-' + theme.buttonFrameWidth} * 2);

    div {
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.buttonLight};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 50%;
        height: 50%;
      }
    }
  }

  &:hover {
    background: ${({ theme }) => theme.background};

    .add-bsider-img {
      scale: 1.2;
    }

    .add-bsider-decorator {
      background: white;
    }
  }

`;
